import {PageRequest} from "../../../models/api/PageRequest";
import {SortedRequest} from "../../../models/api/SortedRequest";
import Page from "../../../models/api/Page";
import {Api} from "../../Api";
import {HttpClient} from "../../_http/HttpClient";
import PlannedFailure from "./PlannedFailure";

export type SearchQuery = { q?: string; isDone?: boolean | null; } & PageRequest & SortedRequest;

export type CreateUpdatePayload = {
    location: string;
    description: string;
    date: string;
    isDone: boolean;
}

class PlannedFailureAPI {
    static search(q: SearchQuery): Promise<Page<PlannedFailure>> {
        const url = Api.getUrl("/planned/failure")
        return HttpClient.get(url, q);
    }

    static get(id: number | string): Promise<Page<PlannedFailure>> {
        const url = Api.getUrl(`/planned/failure/${id}`)
        return HttpClient.get(url, {});
    }

    static delete(id: number | string): Promise<any> {
        const url = Api.getUrl(`/planned/failure/${id}/delete`);
        return HttpClient.deleteAndExpectNoContent(url, {}, {});
    }

    static create(payload: CreateUpdatePayload): Promise<PlannedFailure> {
        const url = Api.getUrl("/planned/failure/create");
        return HttpClient.post(url, {}, payload);
    }

    static update(id: number | string, payload: CreateUpdatePayload): Promise<PlannedFailure> {
        const url = Api.getUrl(`/planned/failure/${id}/update`);
        return HttpClient.put(url, {}, payload);
    }
}

export default PlannedFailureAPI;